<template>
  <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 14 }, }"
    ref="ruleForm" >
    <a-form-model-item  label="评定注意事项">
      <a-textarea :rows="2" placeholder="评定注意事项" v-model="model.info" />
    </a-form-model-item>
    <a-form-model-item  label="随访类型">
      <a-select v-model='model.phoneType' placeholder='请选择'>
        <a-select-option :value='item.value' :key="item.value" v-for="item in phoneList">{{ item.text
          }}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item  label="是否使用工具" help="(血压计、血糖仪、影像生物样本等手段)">
      <a-radio-group v-model="model.isTools">
        <a-radio-button value="1">是</a-radio-button>
        <a-radio-button value="0">否</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item  label="评估是否需要专业医护人员" help="(医生、护士、心理咨询师、康复师和影像医师等)">
      <a-radio-group v-model="model.isWorker">
        <a-radio-button value="1">是</a-radio-button>
        <a-radio-button value="0">否</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item  label="采集简易程度" help="(0-5:他评0，其他1;不使用仪器再加0.5分;不需要专业人士加2分,到院0分，其他0.5分;采集时间不超过3分钟再加1分)">
      <a-input-number v-model="model.simplicity" :min="0" :precision="1" style="width: 100%" placeholder="请输入采集简易程度分值" />
    </a-form-model-item>
    <a-form-model-item  label="应用评价" help="包括应用的广泛性和量表的专业程度(IF超过15分的研究或在队列中使用过的得2分;疾病诊断量表得3分，症状评估量表得2分，其他功能质量量表得1分，只是信数伍输入框。，非量表得0 5分">
      <a-input-number v-model="model.evaluate" :min="0" :precision="1" style="width: 100%" placeholder="请输入应用评价分值" />
    </a-form-model-item>
    <a-form-model-item  label="专家评述" help="标明出处，后用括号写明来源的书籍或网站或文献可参考文献的conclusion部分">
      <a-textarea :rows="2" placeholder="专家评述" v-model="model.intro" />
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: "FormExtendModal",
  props: ['model'],
  data() {
    return {
      title: "操作",
      visible: true,
      phoneList: [
        { text: '电话随访', value: '0' },
        { text: '到院随访', value: '1' },
        { text: '均可', value: '2' },
      ],
    }
  },
}
</script>

<style lang="less" scoped></style>